<template>
  <!-- <div class="">
    <PageHeader> </PageHeader> -->

  <div class="main layout-main">
    <div class="left">
      <div class="nav-left-title">
        <span class="icon-left">
          <!-- <img src="@/assets/images/icons/gongkai.png" class="img" /> -->
          <img :src="$route.meta.icon" class="img" />
        </span>
        <span class="tit"> 信息公开 </span>
      </div>
      <div class="z-menu" id="navLeft">
        <div
          v-for="item in categoryList"
          class="z-menu__item"
          :key="item.cate_id"
          :data-id="item.cate_id"
        >
          <div
            class="z-menu__item-name"
            :class="[
              activeKey === item.cate_id ? 'active' : '',
              'cate_type-' + item.cate_type,
            ]"
            @click="clickItem(item)"
          >
            {{ item.cate_name }}
          </div>
          <div
            class="z-menu__items"
            v-if="item.children && item.children.length"
          >
            <span
              class="z-menu__item-name"
              v-for="item2 in item.children"
              :key="item2.cate_id"
              :class="[
                activeKey2 === item2.cate_id ? 'active' : '',
                'cate_type-' + item2.cate_type,
              ]"
              @click="clickItem2(item2, item)"
            >
              {{ item2.cate_name }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="right" v-loading="loading">
      <div class="nav-right-title">
        <div class="tit">{{ cate_name }}</div>
      </div>
      <!-- <router-view></router-view> -->
      <List
        v-if="activeKey == 7 && !activeKey2"
        :pager="{ total: 0, data: cate_id_7_list }"
        :cate_id="activeKey"
        style="min-height: 800px"
      ></List>
      <List
        v-if="activeKey == 8 && !activeKey2"
        :pager="{ total: 0, data: cate_id_8_list }"
        :cate_id="activeKey"
        style="min-height: 800px"
      ></List>
      <div
        v-for="item in rightList"
        :key="item.cate_id"
        :data-cate_id="item.cate_id"
      >
        <List
          v-if="item.cate_type == 2"
          :pager="item"
          :cate_id="item.cate_id"
          v-show="activeKey == item.cate_id || activeKey2 == item.cate_id"
          style="min-height: 800px"
        ></List>
        <div
          v-else-if="item.cate_type == 1"
          v-show="activeKey == item.cate_id || activeKey2 == item.cate_id"
          style="min-height: 800px"
        >
          <template v-if="item.content">
            <!-- {{ item.title }} -->
            <div class="con" v-html="item.content"></div>
          </template>
        </div>
        <!-- <div
          v-else-if="item.cate_type == 3"
          v-show="activeKey === item.cate_id"
        >
          <template v-if="item.children && item.children.length">
            <List
              :pager="item2.pager"
              :cate_id="item2.cate_id"
              v-for="item2 in item.children"
              :key="item2.cate_id"
              v-show="activeKey2 == item2.cate_id"
            ></List>
          </template>
        </div> -->
      </div>
    </div>
  </div>
  <!-- <PageFooter> </PageFooter>
    <FixedLeft> </FixedLeft>
    <FixedRight> </FixedRight>
  </div> -->
</template>

<script>
// import List from "./components/gongshigonggao.vue";
import List from "./components/List.vue";
import leftNavMixin from "@/views/dangjian/leftNavMixin";
import {
  getCategoryXinxiGongkai,
  getCategoryXinxiGongkaiPage,
  getCategoryXinxiGongkaiItem,
  cate_artile_list,
} from "@/apis/xinxi-gongkai";

export default {
  name: "xinxigongkai",
  mixins: [leftNavMixin],
  components: {
    List,
  },
  // beforeRouteEnter(to, from, next) {
  //   // if (to.query.id == 16) {
  //   //   this.activeKey = 7;
  //   //   this.activeKey2 = 16;
  //   //   this.cate_name = to.query.name || "";
  //   // }
  //   next((vm) => {
  //     console.log(vm, to, from);
  //   });
  // },
  data() {
    return {
      // list: {},
      cate_name: "信息公开",
      activeKey: "",
      activeKey2: "",
      categoryList: [],
      rightList: [],
      cate_id_7_list: [],
      cate_id_8_list: [],
      loading: false,
    };
  },
  watch: {
    $route: {
      handler(n) {
        const { query } = n;
        if (query.id && query.id == 16) {
          this.activeKey = 7;
          this.activeKey2 = 16;
          this.cate_name = query.name || "";
        } else {
          this.activeKey = "";
          this.activeKey2 = "";
          this.cate_name = "";
          this.init();
        }
      },
      immediate: true,
    },
  },
  activated() {
    console.log("[ activated ] >");
  },
  created() {
    this.cate7_artile_list(7);
    this.cate8_artile_list(8);
    this.init();
  },
  beforeMount() {},
  methods: {
    clickItem(item) {
      this.cate_name = item.cate_name;
      if (this.activeKey == item.cate_id) {
        this.activeKey = "";
      } else {
        this.activeKey = item.cate_id;
      }
      this.activeKey2 = "";
    },
    // eslint-disable-next-line no-unused-vars
    clickItem2(item2, item) {
      this.cate_name = item2.cate_name;
      this.activeKey2 = item2.cate_id;
      // this.activeKey = item2.cate_id;
      if (item2.url && item2.cate_type === 4) {
        // location.href = item2.url;
        window.open(item2.url);
        // if (item2.url.startsWith("http")) {
        //  this.$router.push(item2.url.split("#")[1]);
        //} else {
        // this.$router.push(item2.url);
        // }
      }
    },
    async init() {
      this.loading = true;
      const { data } = await getCategoryXinxiGongkai({ pid: 0 });
      const tree = data || [];
      //
      if (!this.activeKey) {
        this.activeKey = tree[0].cate_id;
        this.cate_name = tree[0].cate_name;
      }
      //
      // this.categoryList = tree;
      const promiseList = tree.map((v) => {
        //栏目类型：
        // 1 = 文章（直接展示文章详情，请求信息公开文章详情页接口），
        // 2 = 文章列表页（请求信息公开文章列表页接口），
        // 3 = 目录，意思是包含下级栏目（请求信息公开栏目列表接口）
        if (v.cate_type === 1) {
          // return this.getCategoryXinxiGongkaiItem(v.cate_id);
          return Promise.resolve({});
        } else if (v.cate_type === 2) {
          // return this.getCategoryXinxiGongkaiPage(v.cate_id);
          return Promise.resolve({});
        } else if (v.cate_type === 3) {
          return this.getCategoryXinxiGongkai(v.cate_id, v.cate_type);
        } else {
          return Promise.resolve({});
        }
      });
      // console.log("promiseList", promiseList);
      Promise.all(promiseList).then((resList) => {
          // console.log("resList", resList);
          tree.forEach((v, i) => {
            // console.log(resList[i]);
            // const value = JSON.parse(JSON.stringify(resList[i].value));
            if (v.cate_type === 1) {
              // tree[i].content = value || {};
            } else if (v.cate_type === 2) {
              // tree[i].pager = value || {};
            } else if (v.cate_type === 3) {
              tree[i].children = resList[i];
            }
          });
          this.categoryList = tree;
          this.loading = false;
          const promiseList2 = tree.reduce((prev, cur) => {
              if (cur.children && cur.children.length) {
                prev.push(...cur.children);
              } else {
                prev.push(cur);
              }
              return prev;
            }, []).map((v) => {
              if (v.cate_type === 1) {
                return this.getCategoryXinxiGongkaiItem(v.cate_id, v.cate_type);
              } else if (v.cate_type === 2) {
                return this.getCategoryXinxiGongkaiPage(v.cate_id, v.cate_type);
              } else if (v.cate_type === 3) {
                return this.getCategoryXinxiGongkai(v.cate_id, v.cate_type);
              } else {
                return Promise.resolve({});
              }
            });
          Promise.all(promiseList2).then((resList2) => {
            this.rightList = resList2.map((v) => v);
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // eslint-disable-next-line no-unused-vars
    getCategoryXinxiGongkai(pid, cate_type) {
      return new Promise((resolve, reject) => {
        getCategoryXinxiGongkai({
          pid,
        })
          .then(({ data }) => {
            // resolve({ cate_type, ...data });
            resolve(data);
          })
          .catch(reject);
      });
    },
    getCategoryXinxiGongkaiPage(cate_id, cate_type) {
      return new Promise((resolve, reject) => {
        getCategoryXinxiGongkaiPage({
          cate_id,
          page: 1,
          pagenum: 10,
        })
          .then(({ data }) => {
            resolve({ cate_id, cate_type, ...data });
          })
          .catch(reject);
      });
    },
    getCategoryXinxiGongkaiItem(cate_id, cate_type) {
      return new Promise((resolve, reject) => {
        getCategoryXinxiGongkaiItem({
          cate_id,
        })
          .then(({ data }) => {
            resolve({ cate_id, cate_type, ...data });
          })
          .catch(reject);
      });
    },
    async cate7_artile_list(cate_id = 7) {
      const { data } = await cate_artile_list({
        cate_id,
        page: 1,
        pagenum: 10,
      });
      this.cate_id_7_list = (data.data || []).map((v) => {
        v.article_id = v.id;
        return v;
      });
    },
    async cate8_artile_list(cate_id = 7) {
      const { data } = await cate_artile_list({
        cate_id,
        page: 1,
        pagenum: 10,
      });
      this.cate_id_8_list = (data.data || []).map((v) => {
        v.article_id = v.id;
        return v;
      });
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
@import "~@/styles/nav-layout.scss";
::v-deep .page-content {
  min-height: 900px;
}

.z-menu {
  &__items {
    display: none;
    height: 0;
    opacity: 0;
    transition: all 0.3s;
    .z-menu__item-name {
      padding-left: 38px + 14px;
      &::before {
        left: 24px + 14px;
      }
    }
  }
  &__item-name.active + &__items {
    display: block;
    height: inherit;
    opacity: 1;
  }
  &__item {
  }
  &__item-name {
    height: 62px;
    line-height: 62px;
    display: block;
    position: relative;
    padding-left: 38px;
    color: #303133;
    font-weight: bold;
    cursor: pointer;
    font-size: 16px;
    font-size: var(--font-size-16);
    position: relative;
    z-index: 11;
    user-select: none;

    &::before {
      content: "";
      position: absolute;
      left: 24px;
      top: 50%;
      transform: translateY(-50%);
      border-width: 4px;
      width: 0;
      height: 0;
      border-style: solid;
      border-color: transparent transparent transparent #303133;
      transition: transform 0.3s;
    }
    &.cate_type-1,
    &.cate_type-2,
    &.cate_type-4 {
      &::before {
        display: none;
      }
    }
    &.cate_type-3.active {
      &::before {
        transform: rotate(90deg);
        transform-origin: center;
      }
    }
    &.router-link-exact-active,
    &.active {
      color: #0d7ce4;
      background-color: #c7e3fe;

      &::before {
        border-left-color: #0d7ce4;
      }
    }
  }
}
</style>
